<template>
    <div>
        <el-descriptions class="margin-top" title="展示位" :column="1" size="" border>
            <template slot="extra">
                <el-button type="primary" size="small" v-if="isAdd" @click="addClick">添加</el-button>
                <el-button type="primary" size="small" v-else @click="editClick">修改</el-button>
            </template>
            <el-descriptions-item>
                <template slot="label">en-title:</template>
                {{ tableData.en && tableData.en.title }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">en-description:</template>
                {{ tableData.en && tableData.en.summary }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">zh-title:</template>
                {{ tableData.zh && tableData.zh.title }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">zh-description:</template>
                {{ tableData.zh && tableData.zh.summary }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">topic:</template>
                <el-tag size="small" v-if="tableData.topic">{{ tableData.topic }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">banner:</template>
                <img :src="`https://asset.promptport.ai/files${tableData.banner_url}`" alt="" style="height: 200px" v-if="tableData.banner_url" />
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">浏览量:</template>
                {{ tableData.view }}
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">是否外链:</template>
                <el-tag size="small" v-if="tableData.topic">{{ tableData.web_link ? '是' : '否' }}</el-tag>
            </el-descriptions-item>

            <el-descriptions-item v-if="tableData.web_link">
                <template slot="label">外链地址:</template>
                {{ tableData.link_url ? tableData.link_url : '' }}
            </el-descriptions-item>

            <template v-else>
                <el-descriptions-item>
                    <template slot="label">详情预计阅读时长:</template>
                    <el-tag size="small" v-if="tableData.read_time">{{ tableData.read_time }} min</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">en-detail:</template>
                    <div v-html="tableData.en && tableData.en.detail"></div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">zh-detail:</template>
                    <div v-html="tableData.zh && tableData.zh.detail"></div>
                </el-descriptions-item>
            </template>
        </el-descriptions>

        <ModalCom v-if="modalFlag" :dialogVisible="modalFlag" :type="modalType" :initData="modalData" :isMain="1" @closeModal="handleCloseModal" />
    </div>
</template>

<script>
import serverApi from '../../../server/index';
import ModalCom from '../components/modal.vue';
export default {
    name: 'placement-blog',
    components: {
        ModalCom,
    },
    data() {
        return {
            isAdd: false,
            tableData: [],
            tableLoad: false,
            // modal
            modalFlag: false,
            modalType: 'add',
            modalData: null,
        };
    },
    mounted() {
        this.initData();
    },
    methods: {
        async initData() {
            this.tableLoad = true;
            try {
                const { data } = await serverApi.blogList({ is_main: 1 });
                if (data.code !== 0) throw new Error(data.error);
                this.isAdd = data.data.length === 0;
                console.log('blog main---->', data, this.isAdd);
                if (!this.isAdd) {
                    this.tableData = data.data[0];
                }
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.tableLoad = false;
            }
        },
        addClick() {
            this.modalType = 'add';
            this.modalFlag = true;
        },
        editClick() {
            this.modalType = 'edit';
            this.modalData = this.tableData;
            this.modalFlag = true;
        },
        handleCloseModal(isUpdate) {
            console.log('close--->', isUpdate);
            this.modalFlag = false;
            if (isUpdate) {
                this.initData();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}

h4 {
    margin-bottom: 30px;
}

h5 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.demo-input-suffix {
    display: flex;
    align-items: center;
    margin-right: 20px;
}
</style>
